<template>
  <div class="modal" tabindex="-1" role="dialog" style="display:block!important">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{title}}
          </h5>
        </div>
        <div class="modal-body text-center">
          <div>
            <canvas ref="pdf" id="pdf_crop" v-if="!png"></canvas>
            <img ref="pdf" id="pdf_crop" v-if="png" :src="png" alt="">
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="_cancel()" v-if="png">Abbrechen</button>
          <button class="btn btn-success" @click="_confirm()">Fertig</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop"></div>
</template>

<script>

import * as PDFJS from 'pdfjs-dist/build/pdf.min.js';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
  name: "TemplateCropModal",
  props: ['image', 'initialBounds', 'png', 'aspectRatio', 'title'],
  emits: ['crop', 'cancel'],
  data() {
    return {
      cropper: '',
      bounds: {x: 0, y: 0, w: 0, h: 0},
      imageData: ''
    }
  },
  mounted() {
    let that = this;
    if(this.png) {
      let data = {};
      if(this.initialBounds) {
        data = {
          x: this.initialBounds.x,
          y: this.initialBounds.y,
          width: this.initialBounds.w,
          height: this.initialBounds.h
        };
      }
      this.cropper = new Cropper(document.getElementById('pdf_crop'), {
        aspectRatio: this.aspectRatio,
        data: data,
        crop(event) {
          that.bounds = {
            x: Math.round(event.detail.x), y: Math.round(event.detail.y), w: Math.round(event.detail.width), h: Math.round(event.detail.height)
          }
        },
      });
      return
    }
    PDFJS.getDocument({data: new Uint8Array(this.image)}).promise.then(pdf => {
      pdf.getPage(1).then(page => {
        let viewport = page.getViewport({scale: 1});
        let ctx = this.$refs.pdf.getContext('2d');
        let renderContext = { canvasContext: ctx, viewport: viewport };
        this.$refs.pdf.height = viewport.height;
        this.$refs.pdf.width = viewport.width;
        page.render(renderContext).promise.then(() => {
          this.$refs.pdf.toBlob((blob) => {
            this.imageData = blob;
          })
          let data = {};
          if(this.initialBounds) {
            data = {
              x: this.initialBounds.x,
              y: this.initialBounds.y,
              width: this.initialBounds.w,
              height: this.initialBounds.h
            };
          }
          this.cropper = new Cropper(document.getElementById('pdf_crop'), {
            aspectRatio:  this.aspectRatio,
            data: data,
            crop(event) {
              that.bounds = {
                x: Math.round(event.detail.x), y: Math.round(event.detail.y), w: Math.round(event.detail.width), h: Math.round(event.detail.height)
              }
            },
          });
        });
      })
    })
  },
  methods: {
    _confirm() {
      console.log(this.bounds);
      this.$emit('crop', {bounds: this.bounds, image: this.imageData});
    },
    _cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
#pdf_crop {
  display: block;
  /* This rule is very important, please don't ignore this */
  max-width: 100%;
}
</style>